
import React from 'react';
import Menu from '../MenuBar';
import checkToken from '../../Token/checkToken'
import Card from 'react-bootstrap/Card'
import IconButton from '@mui/material/IconButton';
import GetAppIcon from '@mui/icons-material/GetApp';
import FileSaver from 'file-saver';
import { withTranslation } from 'react-i18next';
import deFlagImage from './../../flags/de.png';
import ukFlagImage from './../../flags/uk.png';
import brFlagImage from './../../flags/br.png';
import i18n from '../../i18n';

// import {IconFlagDE, IconFlagUK, IconFlagBR} from 'material-ui-flags';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';


class HomeView extends React.Component {

    constructor(props) {
        super(props)
        this.state = { firstname:  localStorage.getItem('firstname'), lastname: localStorage.getItem('lastname') }
        this.handleManualDownload = this.handleManualDownload.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleShowVideo = this.handleShowVideo.bind(this);
    }

    // async componentDidMount() {

    //     // localStorage.getItem('firstname')
    //     // const response = await fetch(`/home/check/person?user_id=${localStorage.getItem('user_id')}`)
    //     // const json = await response.json();
    //     // console.log( localStorage.getItem('firstname'))
    //     // console.log( localStorage.getItem('lastname'))
    //     // console.log(localStorage.getItem('user_id'))
    //     // console.log(localStorage.getItem('role_id'))
    //     // this.setState({ firstname: localStorage.getItem('firstname'), lastname: localStorage.getItem('lastname') });
    // }

    handleShowVideo() {
        
        let language = localStorage.getItem('language')

        if (language === "de") {
            window.open("https://intranet.mc-bauchemie.de/communities/marketingkommunikation/marketingmc/Shared%20Media/Ref%20App%20Erklaerung.mp4", "_blank")
        } else {
            window.open("https://vimeo.com/824054522/2cab145964", "_blank")
        }

    }

    handleClick(lang) {
        i18n.changeLanguage(lang)
        localStorage.setItem('language', lang)
        window.location.reload();
    }

    async handleManualDownload() {

        await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/downloadManual?language=${localStorage.getItem('language')}`, {
            method: 'GET',
        }).then(async response => {
            const blob = await response.blob();
            FileSaver.saveAs(blob, 'Ref-Atpp Manual.pdf');
        }).catch((err) => {
            if (err) {
                console.log(err)
            }
        });
    }
    render() {
        
        const { t } = this.props;

        return (
            <div className='homeRefClassFull'>
                {checkToken() ?
                    <div >
                        <Menu />
                        <div className='createRefClass'>
                            <Card style={{ margin: 10, top: 50, backgroundColor: 'rgba(0, 0, 0, 0.4)', color: 'white' }}>
                                <Card.Header>Select language:   
                                <IconButton style={{ size: 'small', padding: 0, margin: 5, marginLeft: 10 }} aria-label="previousImage" onClick={() => this.handleClick('de')} >
                                    <img src={deFlagImage} alt="DE Flag" style={{ width: '24px', height: '24px' }} />
                                </IconButton>
                                <IconButton style={{ size: 'small', padding: 0, margin: 5}} aria-label="previousImage" onClick={() => this.handleClick('en')} >
                                    <img src={ukFlagImage} alt="DE Flag" style={{ width: '24px', height: '24px' }} />
                                </IconButton>
                                <IconButton style={{ size: 'small', padding: 0, margin: 5}} aria-label="previousImage" onClick={() => this.handleClick('pt-br')} >
                                    <img src={brFlagImage} alt="DE Flag" style={{ width: '24px', height: '24px' }} />
                                </IconButton>
                                </Card.Header>
                                <Card.Body>
                                    <Card.Title> {t('home.welcome')} {this.state.firstname} {this.state.lastname}! </Card.Title>
                                    <Card.Text>
                                        {/* <div style={{color: 'yellow', fontSize: 20, fontWeight: 'bold'}}>{t('home.alert')}</div> */}
                                        {t('home.info')}
                                        <b>{t('home.download_instructions')}</b>
                                        <IconButton style={{ size: 'small' }} aria-label="previousImage" onClick={this.handleManualDownload} >
                                        <GetAppIcon style={{ color: 'white' }} />
                                        </IconButton>
                                        <b>{t('home.watch_video')}</b>
                                        <IconButton style={{ size: 'small' }} aria-label="previousImage" onClick={this.handleShowVideo} >
                                            <OndemandVideoIcon style={{ color: 'white' }} />
                                        </IconButton>
                                        {t('home.team')}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </div>
                    </div>

                    : window.location.reload()}
            </div>
        )
    }
}

export default withTranslation()(HomeView);